import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-foreground">
      <h1 className="text-4xl font-bold mb-4">Oops!</h1>
      <p className="text-xl mb-6">Sorry, the page you're looking for doesn't exist.</p>
      <Link 
        to="/" 
        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
      >
        Go back home
      </Link>
    </div>
  );
} 